import { sis_giaidoan } from './../../../models/response/so-diem/sis_giaidoan';
import { eGiaiDoanActionTypeIds } from './../../action-types/so-diem/IGiaiDoanActions';
import { BaseAction } from "../IBaseActionResult";

export const giaiDoanActions = {
    loadStart: () => BaseAction(undefined, eGiaiDoanActionTypeIds.LOAD_START),
    loadSuccess: (respone: sis_giaidoan[]) => BaseAction(respone, eGiaiDoanActionTypeIds.LOAD_SUCCESS),
    loadError: (message: string) => BaseAction(message, eGiaiDoanActionTypeIds.LOAD_ERROR),
}